import React from "react";

import ArticleLayout from "../../../../components/v2/Noticias/ArticleLayout";

export default function AtendimentoEmCasa() {
  return (
    <ArticleLayout slug="atendimento-em-casa">
      <p>O <strong>atendimento presencial</strong> ocorrerá mediante o agendamento prévio, para os seguintes casos:</p>
      <ul>
        <li><strong>Grandes negociações:</strong> com mais de 150 Certidões de Dívidas Ativas (CDA);</li>
        <li><strong>Prioridades:</strong> pessoas portadoras de deficiência física, idosos com idade igual ou superior a 60 anos, gestantes, lactantes e pessoas acompanhadas por crianças de colo;</li>
        <li><strong>Espólio:</strong> assuntos relacionados a espólios em Dívida Ativa;</li>
      </ul>
      <p>Ressaltamos que qualquer outro caso de atendimento que não esteja citado acima, acesse: <a href="/#atendimento">Balcão Virtual</a> ou baixe o aplicativo <a href="/#atendimento">Dívida Ativa</a>.</p>
      <h2 className="pgm-title-large">Contato</h2>
      <p>
        Atendimento de Dívida Ativa <br /> (Procuradoria da Fazenda)
      </p>
      <ul>
        <li>(85) 98419-2045</li>
        <li>(85) 98419-2042</li>
      </ul>
    </ArticleLayout>
  );
}
